import React, { useEffect, useState } from "react";
import { getMyAttendance } from "../api/attendance";
import { logoutFromFrappe } from "../api/authf";

export default function AttendancePage({ user, onLogout }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        (async () => {
            setLoading(true);
            try {
                // Example: last 31 days (change as needed)
                const data = await getMyAttendance({ limit: 50 });
                setRows(data);
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    const logout = async () => {
        await logoutFromFrappe();
        localStorage.removeItem("frappe_login_response");
        localStorage.removeItem("frappe_user");
        onLogout();
    };

    return (
        <div style={{ maxWidth: 900, margin: "30px auto", padding: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <h2>Attendance</h2>
                <div>
                    <span style={{ marginRight: 12 }}>Logged in: <b>{user}</b></span>
                    <button onClick={logout}>Logout</button>
                </div>
            </div>

            {loading ? (
                <p>Loading...</p>
            ) : (
                <table border="1" cellPadding="10" style={{ width: "100%" }}>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Status</th>
                            <th>Employee</th>
                            <th>Doc Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((r) => (
                            <tr key={r.name}>
                                <td>{r.attendance_date}</td>
                                <td>{r.status}</td>
                                <td>{r.employee}</td>
                                <td>{r.name}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}
